import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import module from 'app/modules/option-type/option-type.module';

@Component({
  selector: 'app-add-option-type',
  templateUrl: './add-option-type.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-option-type.component.scss']
})
export class AddOptionTypeComponent {
  public optionData = {
    name : '',
    description : ''
  }

  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddOptionTypeComponent>,
    public dialog: MatDialog,
    public metadataService: OptionTypeService) { }

  addOptions() {
    this.isLoading = true

    this.metadataService.createOption(this.optionData).subscribe((res)=>{
      this.isLoading = false
      this.closeDialog()
    })
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }
}
